"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { PiggyBank, Calendar, Clock, User, CircleX, Heart, Handshake, ThumbsUp, MessageSquare, CircleCheck } from "lucide-react";
const reasons = [{
  id: "budget",
  icon: PiggyBank,
  title: "COMPETITIVE PAY",
  description: "We offer industry-leading salaries that reflect your expertise and value."
}, {
  id: "timing",
  icon: Calendar,
  title: "HEALTH & WELLNESS",
  description: "Comprehensive benefits including dental, vision, and mental health support."
}, {
  id: "deciding",
  icon: Clock,
  title: "PROFESSIONAL GROWTH",
  description: "Annual budget for certifications, workshops, and continuous learning."
}, {
  id: "someone-else",
  icon: User,
  title: "HYBRID FLEXIBILITY",
  description: "Balance your life with our flexible work-from-home and office model."
}, {
  id: "not-doing",
  icon: CircleX,
  title: "RETIREMENT SAVINGS",
  description: "Generous matching programs to help you secure your financial future."
}];
const values = [{
  id: "respect",
  icon: Handshake,
  text: "We foster a culture of mutual respect and collaboration."
}, {
  id: "appreciate",
  icon: ThumbsUp,
  text: "Your contributions are recognized and celebrated regularly."
}, {
  id: "courtesy",
  icon: MessageSquare,
  text: "Open channels for feedback and transparent leadership."
}, {
  id: "relationships",
  icon: Heart,
  text: "Building long-term careers through supportive mentorship."
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4 animate-pulse">
        <div className="h-4 w-20 bg-muted rounded-md" />
        <div className="h-4 w-20 bg-muted rounded-md" />
        <div className="h-4 w-20 bg-muted rounded-md" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors">
          {item.label}
        </Link>)}
    </nav>;
}
export default function GhostingProblemAndValues() {
  return;
}